export default "__VITE_ASSET__DoJJQAF2__"